module.exports = __webpack_public_path__ + "static/media/PRISM_4562.dd97c4d8.jpg";